import { render, staticRenderFns } from "./day_stat.vue?vue&type=template&id=1f730722&scoped=true&"
import script from "./day_stat.vue?vue&type=script&lang=js&"
export * from "./day_stat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f730722",
  null
  
)

export default component.exports